import * as React from 'react';
import { Event } from '../../../../types';
import './InputRange.css';

interface Props {
    id: string;
    onChange: Function;
}

class InputRange extends React.Component<Props> {
    state = {
        value: 5
    };

    handleChange(e: Event) {
        const value = e.target.value;
        const { onChange, id } = this.props;

        this.setState({ value }, () => { onChange(value, id); });
    }

    render() {
        const { id } = this.props;
        const { value } = this.state;

        return (
            <div className="input-range-wrapper">
                <div className="range-control">
                    <div className="markers">
                        <div>0</div>
                        <div>1</div>
                        <div>2</div>
                        <div>3</div>
                        <div>4</div>
                        <div>5</div>
                        <div>6</div>
                        <div>7</div>
                        <div>8</div>
                        <div>9</div>
                        <div>10</div>
                    </div>
                    <input
                        id={id}
                        type="range"
                        min="0"
                        value={value}
                        max="10"
                        step="1"
                        onChange={(e: Event) => this.handleChange(e)}
                    />
                </div>
                <div className="bottom-labels">
                    <div>Do not Agree at all</div>
                    <div>Completely Agree</div>
                </div>
            </div>
        );
    }
}

export default InputRange;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/general/InputRange.tsx